module.exports = __webpack_public_path__ + "img/guide3.13a3dc1a.png";